import { DefaultLayout } from "app/features/navigation/templates/DefaultLayout";
import { Stack } from "expo-router";
import { AuthGuard } from "app/features/authentication/guards/AuthGuard";
import { ActionSignatureProvider } from "app/features/actionSignature/providers/ActionSignatureProvider";
import { ModalProvider } from "ui/providers/ModalManager";
import { useOfflinePrefetch } from "app/services/offline/hooks/useOfflinePrefetch";
import { useSessionManager } from "app/features/authentication/hooks/useSessionManager";
import { useNetworkReconnectStatusCheck } from "app/features/offline/hooks/useNetworkReconnectStatusCheck";
import { ReportGenerationProvider } from "app/features/reporting/providers/ReportGenerationProvider";

export default function AuthLayout() {
  useOfflinePrefetch();
  useSessionManager();
  useNetworkReconnectStatusCheck();

  return (
    <AuthGuard>
      <ModalProvider>
        <ActionSignatureProvider>
          <ReportGenerationProvider>
            <DefaultLayout>
              <Stack
                screenOptions={{
                  headerShown: false,
                  contentStyle: { backgroundColor: "white" },
                }}
              />
            </DefaultLayout>
          </ReportGenerationProvider>
        </ActionSignatureProvider>
      </ModalProvider>
    </AuthGuard>
  );
}
